export default __webpack_public_path__ + "static/localisation-d994853aa1972bceb384f398deeb85bd.gif";